module.exports = "/_next/static/images/percentage-line-8e451e4f08ec7a7eb5c404f0c9f22a0f.svg";